/* The Majestic Quran (Dr Musharraf Hussain) writes its section headings into the verse text, in
   square brackets and capitals - at the start of a verse ("[THE OPENING] In the name of Allah")
   and sometimes in the middle ("...he has borrowed. [WITNESSES ARE REQUIRED TO PROTECT THOSE
   LIABLE TO EXPLOITATION] If the debtor..."). Every one of them, wherever it sits, becomes a
   small title line (class "qchd", styled once in engine/suite.css).

   Shared by every app: React screens import translationHeadings(), and each app's start-up calls
   installTranslationHeadings() so the classic engine (quiz.js's hint page) uses the same one.
   Only capitals count as a heading, so ordinary bracketed words in other translations are left
   alone. */
const HEADING = /\s*\[([A-Z][^\]a-z]*)\]\s*/g;

export function translationHeadings(text: string): string {
  return String(text || '').replace(HEADING, (_m, h: string) =>
    '<span class="qchd">' + h.charAt(0) + h.slice(1).toLowerCase() + '</span>');
}

declare global {
  // eslint-disable-next-line no-var
  var qcTranslationHeadings: ((text: string) => string) | undefined;
}

/** hands the formatter to the classic engine scripts, which cannot import it */
export function installTranslationHeadings(): void {
  globalThis.qcTranslationHeadings = translationHeadings;
}
